export * from './faq.component';
